import type { SALES_TARGETS } from '../../utils';
import FirstOrderProductBadge from '../FirstOrderProductBadge';

interface Props {
  salesTargets: SALES_TARGETS;
  className?: string;
  full?: boolean;
  border?: boolean;
}

const ProductSalesTargetBadge = ({ salesTargets, ...props }: Props) => {
  if (!salesTargets?.length) return <></>;

  switch (salesTargets[0]) {
    case 'FIRST_ORDER':
      return <FirstOrderProductBadge {...props} />;
    default:
      return <></>;
  }
};

export default ProductSalesTargetBadge;
